export function buildSessionUserTopic(username) {
    const trimmed = username.trim();
    if (!trimmed) {
        throw new Error('Session topic requires a username.');
    }
    return `/topic/session.user.${trimmed}`;
}
export function parseSessionEvent(raw) {
    try {
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object')
            return null;
        const event = parsed;
        if (typeof event.eventType !== 'string')
            return null;
        return {
            eventType: event.eventType,
            username: typeof event.username === 'string' ? event.username : undefined,
            forcedBy: typeof event.forcedBy === 'string' ? event.forcedBy : undefined,
            timestamp: typeof event.timestamp === 'string' ? event.timestamp : undefined,
        };
    }
    catch {
        return null;
    }
}
